var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"fixed":"","color":"grey"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('strong',[_vm._v("PRORRECTORÍA - UNIVERSIDAD DE SANTIAGO DE CHILE")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }